// frontend/src/components/FeeStructureTable.js
import React, { useState, useEffect } from 'react';
import {
  Box, Container, Typography, Card, Table, TableBody, TableCell, TableHead,
  TableRow, Alert, TextField, MenuItem, CircularProgress,
} from '@mui/material';
import axios from 'axios';

import { sym } from '../utils/currency';
const API  = process.env.REACT_APP_API_URL;
const hdrs = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

// Legacy fee-structure viewer: pick a stage, see its payment lines.
// (Fee Templates under Academics are the maintained replacement.)
const FeeStructureTable = ({ stage: stageProp }) => {
  const [stages, setStages] = useState([]);
  const [stage, setStage] = useState(stageProp || '');
  const [feeStructure, setFeeStructure] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (stageProp) return; // used as an embedded widget with a fixed stage
    axios.get(`${API}/api/stages`, { headers: hdrs() })
      .then(res => setStages(res.data || []))
      .catch(() => {});
  }, [stageProp]);

  useEffect(() => {
    if (!stage) { setFeeStructure(null); return; }
    setLoading(true); setError('');
    axios.get(`${API}/api/feestructures/${encodeURIComponent(stage)}`, { headers: hdrs() })
      .then(res => setFeeStructure(res.data))
      .catch(err => {
        setFeeStructure(null);
        setError(err.response?.data?.error || 'No fee structure found for this stage');
      })
      .finally(() => setLoading(false));
  }, [stage]);

  return (
    <Container maxWidth="sm">
      <Box py={3}>
        <Typography variant="h5" fontWeight={700} mb={2}>Fee Structure</Typography>

        {!stageProp && (
          <TextField select size="small" label="Stage" value={stage}
            onChange={e => setStage(e.target.value)} sx={{ minWidth: 240, mb: 2, bgcolor: 'white' }}>
            {stages.length === 0 && <MenuItem value="" disabled>No stages found</MenuItem>}
            {stages.map(s => (
              <MenuItem key={s._id || s.code} value={s.code || s.name}>
                {s.name || s.code}
              </MenuItem>
            ))}
          </TextField>
        )}

        {error && <Alert severity="info" sx={{ mb: 2 }}>{error}</Alert>}
        {loading && <Box textAlign="center" py={3}><CircularProgress size={28} /></Box>}

        {!stage && !loading && (
          <Alert severity="info">Select a stage to view its fee structure.</Alert>
        )}

        {feeStructure && !loading && (
          <Card sx={{ borderRadius: 2, overflow: 'hidden' }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ bgcolor: 'grey.50' }}>
                  <TableCell sx={{ fontWeight: 700 }}>Payment Type</TableCell>
                  <TableCell sx={{ fontWeight: 700 }} align="right">Amount ({sym()})</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(feeStructure.payments || []).map(p => (
                  <TableRow key={p.type} hover>
                    <TableCell>{p.type}</TableCell>
                    <TableCell align="right">{(p.amount || 0).toLocaleString()}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Card>
        )}
      </Box>
    </Container>
  );
};

export default FeeStructureTable;
